import React, { useContext, useEffect, useRef } from "react";
import { TwoColumn } from "../../core/layouts";
import QuickLinksLogoContainer from "../QuickLinksLogoContainer";
import AvatarNotificationContainer from "../AvatarNotificationContainer";
import variables from "../../themes/base/styles/variables";
import { AuthContext } from "../../globalContext/auth/authProvider";
import { Client as ConversationsClient } from "@twilio/conversations";
import { ConversationContext } from "../../globalContext/coversation/coversationProvider";
import { NotificationsContext } from "../../globalContext/notifications/notificationsProvider";
import {
  setAllRead,
  setNotificationsCount,
} from "../../globalContext/notifications/notificationsActions";
import { useLocation } from "react-router-dom";

const navbarStyle = {
  display: variables.dFlex,
  justifyContent: variables.spaceBetween,
  padding: `${variables.paddingSmall} ${variables.navbarSidesPadding}`,
  alignItems: variables.alignCenter,
  borderBottom: variables.navBorderBottom,
};

export default function Navbar() {
  const { pathname } = useLocation();
  const [authState] = useContext(AuthContext);
  const [conversationData] = useContext(ConversationContext);
  const [notificationState, notificationDispatch] =
    useContext(NotificationsContext);

  const notificationsAllRead = notificationState.allRead;

  const clientRef = useRef(null);

  useEffect(() => {
    conversationSetup(conversationData);
  }, [conversationData, notificationsAllRead]);

  const conversationSetup = async (data) => {
    if (data?.conversationToken) {
      if (clientRef.current) {
        clientRef.current.removeAllListeners();
      }
      const client = await new ConversationsClient(data.conversationToken);

      client.on("connectionStateChanged", (state) => {
        if (state === "connected") {
          client
            .getConversationBySid(data.conversationSid)
            .then((conversation) => {
              if (conversation) {
                clientRef.current = conversation;
                conversation.on("messageAdded", (message) => {
                  if (message)
                    notificationDispatch(
                      setNotificationsCount(
                        JSON.parse(message?.body)?.unReadCount
                      )
                    );
                });
                conversation.getMessages().then((messages) => {
                  if (messages?.items?.length) {
                    if (notificationsAllRead) {
                      messages.items.forEach((message) => {
                        message.remove().then(() => {});
                      });
                      notificationDispatch(setAllRead(false));
                      notificationDispatch(setNotificationsCount(0));
                    } else {
                      notificationDispatch(
                        setNotificationsCount(
                          JSON.parse(
                            messages.items[messages.items.length - 1].body
                          ).unReadCount
                        )
                      );
                    }
                  } else {
                    notificationDispatch(setNotificationsCount(0));
                  }
                });
              } else {
                console.log("Failed to join conversation");
              }
            });
        }
      });
    }
  };

  return (
    <TwoColumn
      style={navbarStyle}
      leftSection={<QuickLinksLogoContainer />}
      rightSection={
        authState?.currentRole?.id &&
        !pathname.includes("access-denied") && <AvatarNotificationContainer />
      }
    />
  );
}
